const LOCAL_HOSTS = ['localhost', '127.0.0.1', 'localdev.petrocard.online']

export const restoreServerUserType = (authState) => {
  if (!authState || !Object.prototype.hasOwnProperty.call(authState, 'localOriginalUserTypeId')) {
    return authState
  }

  const { localOriginalUserTypeId, ...rest } = authState
  return {
    ...rest,
    user: rest.user && { ...rest.user, user_type_id: localOriginalUserTypeId }
  }
}

export const applyLocalPetrocardAccess = (authState, options = {}) => {
  const originalState = restoreServerUserType(authState)
  const nodeEnv = options.nodeEnv || process.env.NODE_ENV
  const hostname = options.hostname || (typeof window !== 'undefined' && window.location.hostname)
  const configuredEmail = options.email || process.env.REACT_APP_LOCAL_PETROCARD_EMAIL
  const user = originalState && originalState.user

  if (
    nodeEnv !== 'development' ||
    !LOCAL_HOSTS.includes(hostname) ||
    !configuredEmail ||
    !user ||
    !originalState.token ||
    user.email?.trim().toLowerCase() !== configuredEmail.trim().toLowerCase() ||
    user.user_type_id === 1
  ) {
    return originalState
  }

  return {
    ...originalState,
    localOriginalUserTypeId: user.user_type_id,
    user: { ...user, user_type_id: 1 }
  }
}
